import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import WhatsAppButton from '../Components/WhatsAppButton';
import fbaSgStd from '../Photos/Products/FBA SG std.jpg';
import nfxStd from '../Photos/Products/NFX std.jpg';
import nfpStd from '../Photos/Products/NFP std.jpg';
import fbaMaxi from '../Photos/Products/FBA Maxi.jpg';
import nfxMaxi from '../Photos/Products/NFX maxi.jpg';

const initialProducts = [
  {
    id: 1,
    name: 'FBA - Grouse Satin',
    type: 'FBA',
    size: 'Standard',
    image: fbaSgStd,
    link: '/product-grouse-satin',
    description: 'Clay bricks selected for durability and aesthetic effect.'
  },
  {
    id: 2,
    name: 'NFX Range',
    type: 'NFX',
    size: 'Standard',
    image: nfxStd,
    link: '/product-nfx',
    description: 'General building work below damp-proof course.'
  },
  {
    id: 3,
    name: 'NFP Range',
    type: 'NFP',
    size: 'Standard',
    image: nfpStd,
    link: '/product-nfp',
    description: 'Suitable for general building work that is to be plastered.'
  },
  {
    id: 4,
    name: 'Grouse Satin Maxi',
    type: 'FBA',
    size: 'Maxi',
    image: fbaMaxi,
    link: '/product-grouse-satin-maxi',
    description: 'Maxi size clay bricks for durability and aesthetics.'
  },
  {
    id: 5,
    name: 'NFX Maxi',
    type: 'NFX',
    size: 'Maxi',
    image: nfxMaxi,
    link: '/product-nfx-maxi',
    description: 'Maxi size NFX bricks for foundational work.'
  },
  {
    id: 6,
    name: 'NFP Maxi',
    type: 'NFP',
    size: 'Maxi',
    image: nfpStd,
    link: '/product-nfp-maxi',
    description: 'Maxi size NFP bricks for plastered work.'
  }
];

function ProductsPage() {
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);

  const toggleFilter = (value, currentSelected, setSelected) => {
    if (currentSelected.includes(value)) {
      setSelected(currentSelected.filter(item => item !== value));
    } else {
      setSelected([...currentSelected, value]);
    }
  };

  const filteredProducts = initialProducts.filter(product => {
    const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(product.type);
    const sizeMatch = selectedSizes.length === 0 || selectedSizes.includes(product.size);
    return typeMatch && sizeMatch;
  });

  return (
    <main className="min-h-screen bg-zinc-900 text-neutral-200 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-montserrat text-3xl sm:text-5xl font-bold text-white">Our Products</h1>
          <div className="mt-2 mx-auto h-1 w-20 bg-accent-red"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar Filters */}
          <aside className="w-full lg:w-1/4 space-y-8">
            <div className="bg-zinc-800 p-6 rounded-sm border border-zinc-700">
              <h3 className="font-montserrat text-xl font-bold text-white mb-4 border-b border-zinc-700 pb-2">Product Type</h3>
              <div className="space-y-2">
                {['NFP', 'NFX', 'FBA'].map(type => (
                  <label key={type} className="flex items-center space-x-3 cursor-pointer group">
                    <input 
                      type="checkbox" 
                      className="form-checkbox h-5 w-5 text-accent-red rounded border-zinc-600 bg-zinc-700 focus:ring-accent-red focus:ring-offset-zinc-800"
                      checked={selectedTypes.includes(type)}
                      onChange={() => toggleFilter(type, selectedTypes, setSelectedTypes)}
                    />
                    <span className="group-hover:text-white transition-colors">{type}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="bg-zinc-800 p-6 rounded-sm border border-zinc-700">
              <h3 className="font-montserrat text-xl font-bold text-white mb-4 border-b border-zinc-700 pb-2">Size</h3>
              <div className="space-y-2">
                {['Standard', 'Maxi'].map(size => (
                  <label key={size} className="flex items-center space-x-3 cursor-pointer group">
                    <input 
                      type="checkbox" 
                      className="form-checkbox h-5 w-5 text-accent-red rounded border-zinc-600 bg-zinc-700 focus:ring-accent-red focus:ring-offset-zinc-800"
                      checked={selectedSizes.includes(size)}
                      onChange={() => toggleFilter(size, selectedSizes, setSelectedSizes)}
                    />
                    <span className="group-hover:text-white transition-colors">{size}</span>
                  </label>
                ))}
              </div>
            </div>
          </aside>

          {/* Product Grid */}
          <div className="w-full lg:w-3/4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredProducts.map(product => (
                <div key={product.id} className="group bg-zinc-800 rounded-sm overflow-hidden border border-zinc-700 flex flex-col hover:border-accent-red transition-colors duration-300">
                  <div className="overflow-hidden relative h-56 bg-black">
                    <Link to={product.link}>
                      <img 
                        src={product.image} 
                        alt={product.name} 
                        className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
                      />
                    </Link>
                    <div className="absolute top-2 right-2 bg-black/70 text-white text-xs font-bold px-2 py-1 rounded">
                      {product.size}
                    </div>
                  </div>
                  <div className="p-5 flex flex-col flex-grow">
                    {/* <div className="text-xs text-accent-red font-bold uppercase tracking-wider mb-1">{product.type}</div> */}
                    <h3 className="font-montserrat text-lg font-bold text-white mb-2">{product.name}</h3>
                    <p className="text-sm text-neutral-400 mb-4 flex-grow">{product.description}</p>
                    <Link 
                      to={product.link} 
                      className="inline-block bg-transparent border border-neutral-500 text-neutral-300 font-bold uppercase tracking-widest py-2 px-4 rounded-sm hover:bg-accent-red hover:border-accent-red hover:text-white transition-all duration-300 text-center text-xs"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            {filteredProducts.length === 0 && (
              <div className="text-center py-12 bg-zinc-800 rounded-sm border border-zinc-700">
                <p className="text-xl text-neutral-400">No products match your filters.</p>
                <button 
                  onClick={() => {setSelectedTypes([]); setSelectedSizes([]);}}
                  className="mt-4 text-accent-red hover:underline"
                >
                  Clear all filters
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <WhatsAppButton />
    </main>
  );
}

export default ProductsPage;